import { Add, Profile2User } from 'iconsax-react';
import { useSafeMediaUrl } from '@/hooks/use-safe-media-url';

const MentionAllAvatar = () => (
  <div className='flex size-8 items-center justify-center rounded-full bg-base-200'>
    <Profile2User
      variant='Bold'
      className='size-4 text-inverse'
    />
  </div>
);

export interface MentionMenuItemProps {
  id?: number;
  value?: string;
  denotationChar?: string;
  image?: string;
  remarkName?: string;
}

type MentionMenuContainerProps = {
  onClose?: () => void;
};

export const MentionMenuContainer = ({ onClose }: MentionMenuContainerProps) => (
  <div
    id='mention-menu-container'
    className='absolute inset-x-0 bottom-full z-40 overflow-y-auto overflow-x-hidden border-t-base-200 bg-neutral-0 has-[div]:border-t
    [&>.ql-mention-list-container]:!static [&>.ql-mention-list-container]:max-h-60 [&>.ql-mention-list-container]:size-full [&>.ql-mention-list-container]:overflow-y-auto
    desktop:left-18 desktop:right-5 desktop:rounded-lg desktop:has-[div]:border-0 [&_li.selected]:bg-primary/10'>
    <div
      className='btn btn-ghost absolute right-5 top-0 desktop:right-0'
      onMouseDown={(e) => {
        e.preventDefault();
        onClose?.();
      }}>
      <Add className='rotate-45' />
    </div>
  </div>
);

const MentionMenuItem = ({ id, value, image, remarkName }: MentionMenuItemProps) => {
  const { src } = useSafeMediaUrl(image);

  return (
    <div
      role='button'
      className='flex w-full cursor-pointer items-center gap-2 px-5 py-2'>
      {id === -1 ? (
        <MentionAllAvatar />
      ) : (
        <div className='avatar aspect-square rounded-full before:bottom-[7%] before:top-0 size-8'>
          <div className='size-full rounded-full bg-base-100 bg-cover'>
            <img
              src={src}
              alt={remarkName}
              className='bg-neutral-0 object-contain text-center'
            />
          </div>
        </div>
      )}

      <span className='text-body2 desktop:text-body1 truncate w-3/4'>{remarkName || value}</span>
    </div>
  );
};

export default MentionMenuItem;
